
      import API from "!../../../nodevenv/pathak/24/lib/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../nodevenv/pathak/24/lib/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../nodevenv/pathak/24/lib/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../nodevenv/pathak/24/lib/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../nodevenv/pathak/24/lib/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../nodevenv/pathak/24/lib/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../nodevenv/pathak/24/lib/node_modules/css-loader/dist/cjs.js!./colors.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../nodevenv/pathak/24/lib/node_modules/css-loader/dist/cjs.js!./colors.css";
       export default content && content.locals ? content.locals : undefined;
